import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import login from '../views/login/index.vue'
import register from '../views/login/register.vue'
import order from '../views/order'
import goOrder from "@/views/goOrder/index.vue";
import serve from '@/views/serve/index.vue'
import user from '../views/user'
import withdraw from '../views/user/withdraw.vue'
import editPwd from '../views/user/editPwd.vue'
import recharge_record from '../views/user/recharge_record.vue'
import withdrawal_record from '../views/user/withdrawal_record.vue'
import account from '../views/user/account.vue'
import system_messages from '../views/user/system_messages.vue'
import bankcard from '../views/user/bankcard.vue'
import editWithdrawPwd from '../views/user/editWithdrawPwd.vue'
import invite_friends from '../views/user/invite_friends.vue'
import Recharge from '@/views/user/recharge.vue'
import lang from '@/views/user/lang.vue'
import credential from "@/views/user/credential.vue";
import set_avatar from '@/views/user/set_avatar.vue'

// 绑定ERC20,TRC20,BTC 地址信息接口
import bankwallet from '../views/user/bankwallet.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: home
    },
    {
        path: '/order',
        name: 'order',
        component: order
    },
    {
        path: '/goOrder',
        name: 'goOrder',
        component: goOrder
    },
    {
        path: '/serve',
        name: 'serve',
        component: serve
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/register',
        name: 'register',
        component: register,
    },
    {
        path: '/user',
        name: 'user',
        component: user,
    },
    {
        path: '/withdraw',
        name: 'withdraw',
        component: withdraw
    },
    {
        path: '/recharge_record',
        name: 'recharge_record',
        component: recharge_record
    },
    {
        path: '/withdrawal_record',
        name: 'withdrawal_record',
        component: withdrawal_record
    },
    {
        path: '/account',
        name: 'account',
        component: account
    },
    {
        path: '/system_messages',
        name: 'system_messages',
        component: system_messages
    },
    {
        path: '/bankcard',
        name: 'bankcard',
        component: bankcard
    },
    {
        path: '/bankwallet',
        name: 'bankwallet',
        component: bankwallet
    },
    {
        path: '/editPwd',
        name: 'editPwd',
        component: editPwd
    },
    {
        path: '/lang',
        name: 'lang',
        component: lang,
    },
    {
        path: '/credential',
        name: 'credential',
        component: credential
    },
    {
        path: '/editWithdrawPwd',
        name: 'editWithdrawPwd',
        component: editWithdrawPwd
    },
    {
        path: '/recharge',
        name: 'recharge',
        component: Recharge
    },
    {
        path: '/invite_friends',
        name: 'invite_friends',
        component: invite_friends
    },
    {
        path: '/set_avatar',
        name: 'set_avatar',
        component: set_avatar
    }
]

const router = new VueRouter({
    routes,
})
router.beforeEach((to, from, next) => {
    if (!localStorage.getItem('token')) {
        // if (!store.state.isLogin) {
        //     store.commit('SET_MODAL_LOGIN', true)
        //     return
        //   }
    }
    // 在导航开始之前滚动到页面顶部
    window.scrollTo(0, 0);
    next(); // 继续导航
})
Vue.use(VueRouter)

export default router
